<template>
  <div
    v-if="city"
    class="lg:h-72 flex relative justify-center lg:justify-start items-center overflow-hidden rounded-3xl mt-8 lg:mt-0 mx-4 lg:mx-0"
  >
    <div class="lg:h-72 absolute z-0 w-full">
      <img
        v-if="backgroundUrl"
        :src="backgroundUrl"
        :alt="$t('region.city-of', { city: city.name })"
        class="brightness-75 w-full object-cover rounded-3xl"
      />
    </div>
    <div class="h-full flex flex-col justify-between relative z-10 py-20 px-12">
      <div>
        <div class="text-white text-3xl/9 font-bold">
          {{ city.name }}
        </div>
        <div class="text-white mt-2 text-lg/6">
          {{ city.partner_count }} {{ $tc('region.vet-resources', city.partner_count) }}
        </div>
      </div>
      <div class="mt-4">
        <vetster-button
          v-cloak
          :type="null"
          :href="cityUrl"
          size="xl"
          variant="accentPink"
          rel="nofollow"
          class="flex items-center w-fit px-8"
        >
          <span class="font-medium whitespace-nowrap">
            {{ $t('region.explore-vets-near-you') }}
          </span>
        </vetster-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getLanguageSlug } from '@/i18n';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterRegionCityCard',

  mixins: [LocalizesRoutes],

  props: {
    backgroundUrl: {
      type: String,
      default: null,
    },
    city: {
      type: Object,
      required: true,
    },
  },

  computed: {
    cityUrl() {
      // PHP route('region.city.show')
      return this.localizeUrl(`${getLanguageSlug() === 'fr' ? 'ville' : 'city'}/${this.city.slug}`);
    },
  },
};
</script>
